/*
  Per-event postback addresses for templates that always report a lead.
  Merged FIRST into TRANSLATION_MAPS in ./index.js, so existing translations
  still win. Keys are the English source.
*/

const ru = {
  "Ready addresses, one per event. In the network, paste each one into the postback for that event:": "Готовые адреса, по одному на событие. В сети вставьте каждый в постбэк для этого события:",
};

const es = {
  "Ready addresses, one per event. In the network, paste each one into the postback for that event:": "Direcciones listas, una por evento. En la red, pega cada una en el postback de ese evento:",
};

const pt = {
  "Ready addresses, one per event. In the network, paste each one into the postback for that event:": "Endereços prontos, um por evento. Na rede, cole cada um no postback desse evento:",
};

const de = {
  "Ready addresses, one per event. In the network, paste each one into the postback for that event:": "Fertige Adressen, eine pro Ereignis. Füge im Netzwerk jede in das Postback für dieses Ereignis ein:",
};

const fr = {
  "Ready addresses, one per event. In the network, paste each one into the postback for that event:": "Adresses prêtes, une par événement. Dans le réseau, collez chacune dans le postback de cet événement :",
};

const it = {
  "Ready addresses, one per event. In the network, paste each one into the postback for that event:": "Indirizzi pronti, uno per evento. Nella rete, incolla ciascuno nel postback di quell’evento:",
};

const pl = {
  "Ready addresses, one per event. In the network, paste each one into the postback for that event:": "Gotowe adresy, po jednym na zdarzenie. W sieci wklej każdy do postbacku dla tego zdarzenia:",
};

const tr = {
  "Ready addresses, one per event. In the network, paste each one into the postback for that event:": "Hazır adresler, her olay için bir tane. Ağda her birini o olayın postback alanına yapıştırın:",
};

const uk = {
  "Ready addresses, one per event. In the network, paste each one into the postback for that event:": "Готові адреси, по одній на подію. У мережі вставте кожну в постбек для цієї події:",
};

const PER_EVENT_POSTBACKS = { ru, es, pt, de, fr, it, pl, tr, uk };
export default PER_EVENT_POSTBACKS;
